import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { Box, TextField } from '@material-ui/core';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import { useDispatch, useSelector } from 'react-redux';
import {
  storeBlurState,
  storePriceDetailErrors,
  storePriceDetailsInputData,
} from '../store/actions';
import { startQtrValidation } from './utils';

function PaginationBox(props) {
  const { array } = props;
  const dispatch = useDispatch();

  const getInputValues = useSelector(
    (state) => state.sharedState.PriceLevel.priceDetailsInputData
  );
  const getErrorMsgs = useSelector(
    (state) => state.sharedState.PriceLevel.priceDetailErrors
  );
  const updatedPage = useSelector(
    (state) => state.sharedState.PriceLevel.storeUpdatedPage
  );

  const [data, setData] = useState({
    counter: getInputValues.counter,
    pageCount: getInputValues.pageCount,
  });

  const onBlurPagination = () => {
    dispatch(
      storePriceDetailsInputData({
        ...getInputValues,
        counter: data.counter,
        pageCount: data.pageCount,
      })
    );
    // pushing error msg
    let localErr = [...getErrorMsgs];
    if (data.pageCount !== 0) {
      if (data.pageCount > array?.length) {
        localErr.push({
          field: 'pagination',
          errorType: 'required',
          message: constantMessageData.INPUT_VALUE_GRETER_THAN_TOTAL_COUNT,
        });
      } else {
        localErr = localErr.filter((e) => e.field !== 'pagination');
      }
      dispatch(storePriceDetailErrors(localErr));
    }
  };

  const handleClicks = async (action) => {
    const isError = startQtrValidation(updatedPage[data.counter]);
    let blurState = [];
    if (updatedPage[data.counter]) {
      blurState = [...updatedPage[data.counter]];
    }
    blurState =
      blurState.length > 0 &&
      blurState.map((item) => {
        return {
          ...item,
          startQtrErr: item.startQtr === '' ? true : false,
        };
      });
    dispatch(storeBlurState(blurState));
    let localErr = [...getErrorMsgs];
    if (isError) {
      localErr.push({
        fieldName: `startQtr`,
        errorType: `startQtrRequired`,
        message: constantMessageData.CONTRACT_START_QTR,
      });
      dispatch(storePriceDetailErrors(localErr));
    }

    if (getErrorMsgs.length === 0 && !isError) {
      if (action === 'next') {
        setData((prev) => ({
          counter: prev.counter + 1,
          pageCount: prev.pageCount + 1,
        }));
        dispatch(
          storePriceDetailsInputData({
            ...getInputValues,
            counter: getInputValues.counter + 1,
            pageCount: getInputValues.pageCount + 1,
          })
        );
      } else if (data.counter > 0) {
        setData((prev) => ({
          counter: prev.counter - 1,
          pageCount: prev.pageCount - 1,
        }));
        dispatch(
          storePriceDetailsInputData({
            ...getInputValues,
            counter: getInputValues.counter - 1,
            pageCount: getInputValues.pageCount - 1,
          })
        );
      }
    }
  };

  return (
    <Box className="alone-pagination mb-2">
      <Box>
        <Button
          title="Previous "
          className="btns rotate-left"
          data-testid="paginate-arrow-left"
          type="button"
          onClick={() => handleClicks('previous')}
          disabled={getInputValues.counter < 1 || getErrorMsgs.length > 0}
        >
          <SVGComponent iconName="Icon-arrow" />
          <span className="hide-elm">Previous</span>
        </Button>
      </Box>
      <Box>
        <label className="m-0" htmlFor="paginate-count">
          <TextField
            id="paginate-count"
            data-testid="uc-input-paginate"
            variant="outlined"
            className="searchInput input-count"
            size="small"
            value={data.pageCount}
            onChange={(e) => {
              const val = Number(e.target.value);
              const index = Number(e.target.value) - 1;
              const noErrors =
                getErrorMsgs.filter((e) => e.field !== 'pagination')?.length ===
                0;
              let counter = 0;
              if (index > -1 && index <= array.length - 1) {
                counter = index;
              }
              if (noErrors) {
                setData({
                  counter,
                  pageCount: val,
                });
              }
            }}
            onBlur={onBlurPagination}
          />
        </label>
      </Box>
      <Box className="btns">Of {array?.length}</Box>
      <Box>
        <Button
          title="Next "
          className="btns rotate-right ml-0"
          data-testid="paginate-arrow-right"
          type="button"
          onClick={() => handleClicks('next')}
          disabled={
            array.length - 1 === getInputValues.counter ||
            getErrorMsgs.length > 0
          }
        >
          <SVGComponent iconName="Icon-arrow" />
          <span className="hide-elm">Next</span>
        </Button>
      </Box>
    </Box>
  );
}

export default PaginationBox;
